export const REGIONS = {
	FETCH_ACCOUNTS: 'fetchAccounts',
	ADD_ACCOUNT_USER: 'addAccountUser',
	EDIT_ACCOUNT_USER: 'editAccountUser',
	RESET_BACKOFFICE_USER_PASSWORD: 'resetBackOfficeUserPassword',
	DELETE_ACCOUNT_USER: 'deleteAccountUser',
	FETCH_CUSTOMER_ACCOUNTS: 'fetchCustomerAccounts',
	FETCH_CUSTOMER_USERS: 'fetchCustomerUsers',
	RESET_CUSTOMER_USER_PASSWORD: 'resetCustomerUserPassword',
	DELETE_CUSTOMER_USER: 'deleteCustomerUser',
	DELETE_DUPLICATE_ACCOUNT: 'deleteDuplicateAccount',
	DELETE_DOCUMENT: 'deleteDocument',
	UPDATE_CUSTOMER_ASSIGNMENT: 'updateCustomerAssignment',
	FETCH_TOTALS: 'fetchTotals',
	FETCH_COMMISSIONS: 'fetchCommissions',
	FETCH_DOCUMENT_HISTORIES_ENGAGEMENT_CHART: 'fetchEngagementChart',
	FETCH_USERS_ENGAGEMENT_CHART: 'fetchUsersEngagementChart',
	FETCH_DOCUMENTS_ENGAGEMENT_CHART: 'fetchDocumentsEngagementChart',
	FETCH_TOTAL_ADDITIONALS: 'fetchTotalAdditionals',
	FETCH_CHURNED_CUSTOMERS: 'fetchChurnedCustomers',
	FETCH_UNENGAGED_USERS: 'fetchUnengagedUsers',
	FETCH_PRODUCT_MIX: 'fetchProductMix',
	FETCH_COMMISSION_ADDITIONALS: 'fetchCommissionAdditionals',
	CREATE_CUSTOMER: 'createCustomer',
	FETCH_VARIANCE_DATA: 'fetchFFLs',
	UPLOAD_USER_MANUAL: 'uploadUserManual',
	FETCH_RELEASE_NOTES: 'fetchReleaseNotes',
	DOWNLOAD_USER_MANUAL: 'downloadUserManual',
	DELETE_RELEASE_NOTE: 'deleteReleaseNote',
	UPDATE_ACCOUNT_DETAILS: 'updateAccountDetails',
	FETCH_CLOUD_REPORT: 'fetchCloudReport',
	EXPORT_CLOUD_REPORT: 'exportCloudReport',
	EXPORT_COMMISSION_REPORT: 'exportCommissionReport',
	CREATE_FASTBOUND_DELTA_REPORT: 'createFastBoundDeltaReport',
}
